import "./Backdrop.scss";

interface IBackdrop {
  children: React.ReactNode;
  open: boolean;
  onClick?: () => void;
}

const Backdrop = ({ children, open, onClick = () => {} }: IBackdrop) => {
  return (
    <>
      {open ? (
        <div className="backdrop-wrapper open">
          <div className="backdrop" onClick={onClick} />
          {children}
        </div>
      ) : null}
    </>
  );
};

export default Backdrop;
